.link {
  border: none;
  outline: none;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 1rem;
  color: var(--primary-100);
}

.cellButton {
  border: none;
  outline: none;
  text-decoration: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 1rem;
  padding: 0.3rem;
}

.previewCell {
  font-size: 0.5rem !important;
  color: var(--primary-100);
  background-color: var(--color-ffffff);
  border-radius: 30px;
  padding: 5px;
}

.deleteCell {
  color: var(--color-c2436f);
}

.activeCell {
  color: var(--secondary-100);
}
